export enum InventoryTypeEnum {
    SINGLE_SIDE = "Single Side",
    DOUBLE_SIDE = "Double Side",
    // CUBICLE = "Cubicle"
}